const CARDIO_SPECIALTY_ID = '150'

const isCardio = (specialtyIds) => {
  return specialtyIds ? specialtyIds.indexOf(CARDIO_SPECIALTY_ID) !== -1 : false
}

export default isCardio
